var _module_exports = "<div class=\"editor\"></div> ";;
var path = '/app/components/html-textarea.component.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;